import { render, staticRenderFns } from "./LiquidBrowser.vue?vue&type=template&id=44ec5aa6&"
import script from "./LiquidBrowser.vue?vue&type=script&lang=ts&"
export * from "./LiquidBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports